import {EventEmitter, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {UtilService} from "../util/util.service";
import {RequestService} from "../request/request.service";
import {Subject} from "rxjs";

/**
 * This initializer waits until all supplied properties have been set on window before allowing the
 * Angular code to continue.
 */

@Injectable()
export class WindowPropertyInitializer {

  constructor() { }

  wait(properties: string[] = [], type: string = "", emitter: Subject<boolean> = null): Promise<any> {
    return new Promise((resolve, reject) => {

      const propertiesRequired = properties.reduce((acc, p) => {acc[p] = false; return acc;}, {});

      const remainingProperties = () => Object.getOwnPropertyNames(propertiesRequired).filter(p => propertiesRequired[p] === false).join(", ");

      const dotFind = (start: object, path: string) => {
        const dotPath = path.split(".");
        let startObject = start;
        let found = true;
        for (let i = 0; i < dotPath.length; i++) {
          if (startObject[dotPath[i]]) {
            startObject = startObject[dotPath[i]];
          } else {
            found = false;
            break;
          }
        }
        return found;
      };

      console.log(`WindowPropertyInitializer[${type}] waiting for properties to be initialized: ${remainingProperties()}`);

      const check = () => {
        let allDone = true;

        Object.getOwnPropertyNames(propertiesRequired).forEach(dotPath => {
          if (propertiesRequired[dotPath] === false) {
            if (!dotFind(window, dotPath)) {
              allDone = false;
            } else {
              propertiesRequired[dotPath] = true;
            }
          }
        });

        if (allDone) {
          resolve(null);
          console.log(`WindowPropertyInitializer[${type}] got all properties`);
          emitter && emitter.next(true);
        } else {
          console.log(`WindowPropertyInitializer[${type}] waiting for properties to be initialized: ${remainingProperties()}`);
          setTimeout(check, 300);
        }
      };

      setTimeout(check, 0);
    });
  }
}
